"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POLICY_IDS = exports.BONUS_IDS = void 0;
const PARTIES = ['m', 's', 'u', 'k', 'r', 'g'];
const BONUS_SUFFIXES = ['b01', 'b02'];
const POLICY_SUFFIXES = ['p01', 'p02', 'p03', 'p04'];
exports.BONUS_IDS = PARTIES.flatMap((p) => BONUS_SUFFIXES.map((s) => `${p}${s}`));
exports.POLICY_IDS = PARTIES.flatMap((p) => POLICY_SUFFIXES.map((s) => `${p}${s}`));
